<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".renameFileModals" id="renameFileBtn"> </button>
    <div class="modal fade renameFileModals" id="fileModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form @submit.prevent="addFileName" id="createFile" class="createFile">
                    <div class="modal-header">
                        <h5 class="modal-title">Rename File</h5>
                        <button type="button" class="close" id="closeRenameFilePop" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group col-md-12">
                            <input type="text" class="form-control" name="fileReName" id="fileReName" placeholder="Enter File Name" v-model="v$.form.fileReName.$model" >
                            <div class="input-errors" v-for="(error, index) of v$.form.fileReName.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div> 
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary" :disabled="v$.form.$invalid" v-on:click="addReFileName" v-if="formLoader === 1">Update</button>
                        <button type="button" class="btn btn-primary" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                </form> 
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
    helpers,
    required,
    minLength
} from '@vuelidate/validators'
import $ from "jquery";
import {
    encodeBase62,
    decodeTextFromBase62,
    decodeBase62,
} from '../../utils/helper.js'

import 
    { postCommon } 
from '../../utils/api.js'

export default {
    name: 'RenameFileData',
    data() {
        return {
            errorMessage: '',
            formLoader: 1,
            mainId: null,
            oldFilepaths: null,
            form: {
                fileReName: '',
            },
        }
    },
    methods: {
        encodeBase62,
        decodeTextFromBase62,
        decodeBase62,
        async addReFileName() {
            this.formLoader = 2

            let fileName = $('#fileReName').val();
            fileName = fileName.trim();
            
            let _post = {}
            _post = {
                _id: this.mainId,
                newName: fileName,
            }
            this.addFile(_post)
        },
        async addFile(_post) {
            const resp = await postCommon('files/rename-file', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                document.getElementById('closeRenameFilePop').click();
                this.$toast.success(resp.data.message);
                this.$store.state.home.reLoadFileHomeStarredComponent = Math.random();
            } else if (resp.status == 200 && resp.data.status == 'failure') {
                this.errorMessage = resp.data.message;
                this.$toast.error(resp.data.message);
            }
            this.formLoader = 1
        },
        async renameFile(name, _id) {
            this.mainId = _id;
            this.form.fileReName = '';
            this.v$.$reset()
             
            document.getElementById('renameFileBtn').click();
            setTimeout(async () =>
                $("#fileReName").val(name),
                $("#fileReName").focus(),
            500);
        }
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        const alphaNumeric = helpers.withMessage(
            'Only letters, numbers, spaces, dots, underscores, hyphens, and parentheses are allowed.',
            helpers.regex(/^[a-zA-Z0-9 ._()\--]+$/)
        )
        return {
            form: {
                fileReName: {
                    required,
                    alphaNumeric,
                    min: minLength(2)
                }
            },
        }
    },
}
</script>
